import NewsletterSignup from './NewsletterSignup';

export default NewsletterSignup;
